module.exports = __webpack_public_path__ + "img/dprzb.7af79744.png";